// extracted by mini-css-extract-plugin
module.exports = {"CheckboxWrapper":"Checkbox-module--CheckboxWrapper--2ysRe","Checkbox":"Checkbox-module--Checkbox--2NmCs","Checked":"Checkbox-module--Checked--1Gw3n"};